var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgQuoteStart = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quotation-mark-svgrepo-com 5",
    clipPath: "url(#clip0_1_190)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9307 2.74673L15.9307 8.75399C15.9307 9.5687 15.2519 10.2288 14.4146 10.2288C11.4271 10.2288 9.80196 13.2102 9.57673 19.0944H14.4146C15.2519 19.0944 15.9307 19.7551 15.9307 20.5696L15.9307 33.2536C15.9307 34.0679 15.2519 34.7281 14.4146 34.7281H1.51581C0.678146 34.7281 0 34.0674 0 33.2536L0 20.5696C0 17.7488 0.291906 15.1602 0.867345 12.875C1.45752 10.5318 2.36344 8.48307 3.55916 6.78546C4.78953 5.04083 6.32855 3.6718 8.13384 2.71806C9.95131 1.75855 12.0648 1.27189 14.4151 1.27189C15.2519 1.27189 15.9307 1.93202 15.9307 2.74673ZM35.4838 10.2289C36.3207 10.2289 37 9.56819 37 8.75409V2.74684C37 1.93212 36.3208 1.27199 35.4838 1.27199C33.1344 1.27199 31.0206 1.75876 29.2038 2.71817C27.3982 3.6719 25.8583 5.04094 24.6277 6.78557C23.4324 8.48317 22.5265 10.532 21.9362 12.8757C21.3611 15.1617 21.0692 17.7502 21.0692 20.5697V33.2537C21.0692 34.068 21.7482 34.7282 22.5853 34.7282L35.4837 34.7282C36.3206 34.7282 36.9993 34.0675 36.9993 33.2537L36.9993 20.5696C36.9993 19.7553 36.3207 19.0944 35.4837 19.0944H30.7148C30.9366 13.2103 32.538 10.2289 35.4838 10.2289Z",
    fill: "#6D597A",
    fillOpacity: 0.28
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_190"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 36,
    fill: "white"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuoteStart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quote-start.ae9d9877.svg";
export { ForwardRef as ReactComponent };